import React, { useState, useEffect, useContext } from "react";
import { DataGrid } from "@mui/x-data-grid";
import PersistentDataGrid from "../../components/PersistentDataGrid";
import { Link, useNavigate } from "react-router-dom";
import { useMutation, useManualQuery, ClientContext } from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  Dialog,
  MenuItem,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import styled from "styled-components";

import penImg from "../../assets/icons/pen.png";
import trashImg from "../../assets/icons/trash.png";
import previewImg from "../../assets/icons/preview.png";
import publishImg from "../../assets/icons/publish.png";
import unpublishImg from "../../assets/icons/unpublish.png";

import PeopleIcon from "@mui/icons-material/People";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import HowToRegOutlinedIcon from "@mui/icons-material/HowToRegOutlined";

import {
  REFRESH_TOKEN_MUTATION,
  STAFF_MODULE_ACCESS_QUERY,
} from "../../graphQL/user_qry";
import {
  GET_ALL_TERMS_QUERY,
  DELETE_TERM_MUTATION,
  CHANGE_ACTIVATE_STATUS_MUTATION,
} from "../../graphQL/term_qry";
import { GET_COMPONENTS_ANSWERS_BY_FORM_ID_QUERY } from "../../graphQL/component_qry";
import { CLIENT_HAS_PUBLISHED_FORM } from "../../graphQL/form_qry";
import { GET_CLIENT_UUID } from "../../graphQL/client_qry";

import Header from "./Header.js";
import AssignTeamInputDialog from "./AssignTeamInputDialog.js";

import AlertDialog from "../../components/AlertDialog.js";
import AddTermInputDialog from "../../components/AddTermInputDialog.js";
import SelectCurrentTermDialog from "../../components/SelectCurrentTermDialog.js";

import { project_url } from "../../constants/Data";

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -50px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "visible",
    clear: "both",
    borderRadius: "8px",
    height: "870px",
    backgroundColor: "#ffffff",
  },
  ComponentDragBox: {
    float: "left",
  },
  FormDropBox: {
    float: "left",
    marginLeft: "5rem",
    marginTop: ".5rem",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  largeButtonStyle: {
    borderRadius: 4,
    width: "120px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#4080ad",
    textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "&.MuiDataGrid-root": {
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 12,
    },
  },
  selectStyle: {
    minWidth: 130,
    height: 35,
    // paddingRight: 16,
    "& .MuiOutlinedInput-input": {
      textAlign: "left",
    },
  },
  selectTemplateStyle: {
    minWidth: 180,
    height: 35,
    // paddingRight: 16,
    "& .MuiOutlinedInput-input": {
      textAlign: "left",
    },
  },
}));

function TermList() {
  //const [loadData, setLoadData] = useState(false);
  const [loadContent, setLoadContent] = useState(false);
  const [newTermStartDate, setNewTermStartDate] = useState();
  const [previewAlertMsg, setPreviewAlertMsg] = useState([]);
  const [currentTerm, setCurrentTerm] = useState(null);
  const [selectedCurrentTerm, setSelectedCurrentTerm] = useState(null);
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const [alertDeleteMsg, setAlertDeleteMsg] = useState([]);
  const [alertGoFrmScoresPageMsg, setAlertGoFrmScoresPageMsg] = useState([]);
  const [alertClientHasNoPushFrm, setAlertClientHasNoPushFrm] = useState([]);
  const [addTermInputDialog, setAddTermInputDialog] = useState(false);
  const [currentTermDialog, setCurrentTermDialog] = useState(false);
  const [assignTeamInputDialog, setAssignTeamInputDialog] = useState(false);
  const [clientUuid, setClientUuid] = useState("");
  const [clientTermList, setClientTermList] = useState([]);
  const [termView, setTermView] = useState("info"); // info | dates
  const [selectedTemplate, setSelectedTemplate] = useState("");

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  let tenantUserId = 0;
  if (localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;
  if (localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  let loadData = true;
  if (localStorage.getItem("clientId")) clientId = localStorage.getItem("clientId");
  if (clientId == 0) loadData = false;

  let clientName = "";
  if (localStorage.getItem("clientName")) clientName = localStorage.getItem("clientName");

  const [access, setAccess] = useState(true);
  const [viewAccess, setViewAccess] = useState(false);
  const [addAccess, setAddAccess] = useState(false);
  const [editAccess, setEditAccess] = useState(false);
  const [deleteAccess, setDeleteAccess] = useState(false);
  const [assignTeamsAccess, setAssignTeamsAccess] = useState(false);
  const [lockAccess, setLockAccess] = useState(false);
  const [listOfApplicantsAccess, setListOfApplicantsAccess] = useState(false);
  const [attendanceAccess, setAttendanceAccess] = useState(false);
  const [noteAccess, setNoteAccess] = useState(false);
  const [previewAccess, setPreviewAccess] = useState(false);
  const [setCurrentTermAccess, setSetCurrentTermAccess] = useState(false);
  const [termCompletedWarning, setTermCompletedWarning] = useState({});

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const classes = useStyles();

  const checkAccess = async () => {
    //check if staff has access to module

    const {
      loading: accessDataLoading,
      error: accessDataError,
      data: accessData,
    } = await checkStaffModuleAccess({
      variables: {
        tenantUserId: parseInt(tenantUserId),
        clientId: parseInt(clientId),
        moduleName: "Terms",
        modulepageName: "List",
      },
    });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {
      setAccess(accessData.staffModuleAccess.access);
      let commonActions = accessData.staffModuleAccess.commonActions.split("|");
      if (commonActions.find(a => a == "View")) setViewAccess(true);
      if (commonActions.find(a => a == "Add")) setAddAccess(true);
      if (commonActions.find(a => a == "Edit")) setEditAccess(true);
      if (commonActions.find(a => a == "Delete")) setDeleteAccess(true);

      let additionalActions = accessData.staffModuleAccess.additionalActions.split("|");
      if (additionalActions.find(a => a == "Assign Teams")) setAssignTeamsAccess(true);
      if (additionalActions.find(a => a == "Activate/Deactivate")) setLockAccess(true);
      if (additionalActions.find(a => a == "List of Applicants"))
        setListOfApplicantsAccess(true);
      if (additionalActions.find(a => a == "Teams Resources Attendance"))
        setAttendanceAccess(true);
      if (additionalActions.find(a => a == "Teams Resources Note")) setNoteAccess(true);
      if (additionalActions.find(a => a == "Set Current Term"))
        setSetCurrentTermAccess(true);
      if (additionalActions.find(a => a == "Preview Form")) setPreviewAccess(true);
    }

    if (
      accessDataError &&
      accessDataError.graphQLErrors &&
      accessDataError.graphQLErrors[0].message === "Signature has expired"
    ) {
      navigate(`${project_url}/signin`);
    }
  };

  const formatter = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const dayFormat = day => {
    let newFormat = "-";
    if (day) {
      const dayDate = new Date(day);
      const dayFormat = formatter.formatToParts(dayDate);
      newFormat =
        dayFormat.find(a => a.type == "month").value +
        "/" +
        dayFormat.find(a => a.type == "day").value +
        "/" +
        dayFormat.find(a => a.type == "year").value;
    }
    return newFormat;
  };

  const [fetchAllTerms] = useManualQuery(GET_ALL_TERMS_QUERY, {
    fetchPolicy: "network-only",
  });

  const [clientHasPubForm] = useManualQuery(CLIENT_HAS_PUBLISHED_FORM);

  const [fetchFormComponentsAnswers] = useManualQuery(
    GET_COMPONENTS_ANSWERS_BY_FORM_ID_QUERY,
    {
      fetchPolicy: "network-only",
    },
  );

  const [getClientUuid] = useManualQuery(GET_CLIENT_UUID);
  const getCurrClientUuid = async () => {
    if (clientId != 0) {
      const {
        loading: loadingClientUuid,
        error: errorClientUuid,
        data: dataClientUuid,
      } = await getClientUuid({
        variables: {
          clientId: parseInt(clientId),
        },
      });
      if (!loadingClientUuid && dataClientUuid) {
        setClientUuid(dataClientUuid.getClientData.clientUuid);
      }
      if (errorClientUuid) {
        if (errorClientUuid.graphQLErrors[0].message === "Signature has expired")
          navigate(`${project_url}/signin/?next=${pathname}`);
      }
    }
  };

  const [alertActivateMsg, setAlertActivateMsg] = useState([]);

  const goFrmScoresPageFunc = formUuid => {
    navigate(`${project_url}/forms/` + formUuid + "/assign-score");
  };

  const confirmActivateStatus = async (row, urlActivated) => {
    if (urlActivated) {
      // #================================================================
      // # Check if all the answers in questions in the form used in the
      // # chosen term is Zero
      // #================================================================

      const {
        loading: formComponentsAnswersLoading,
        error: formComponentsAnswersError,
        data: formComponentsAnswersData,
      } = await fetchFormComponentsAnswers({
        variables: { formUuid: row.formUuid },
      });

      if (
        !formComponentsAnswersLoading &&
        formComponentsAnswersData &&
        formComponentsAnswersData.formComponentAnswerList
      ) {
        let findScore = false;
        for (var i in formComponentsAnswersData.formComponentAnswerList.componentList) {
          if (findScore) break;
          let frmCmp = formComponentsAnswersData.formComponentAnswerList.componentList[i];
          for (var j in frmCmp.answerList) {
            let frmCmpAnswrLst = frmCmp.answerList[j];
            if (frmCmpAnswrLst.score && frmCmpAnswrLst.score > 0) {
              findScore = true;
              break;
            }
          }
        }
        if (!findScore) {
          setAlertGoFrmScoresPageMsg({
            title: "Activate Term",
            type: "goFormScoresPage",
            msg: "This term cannot be activated, because the form it uses has not been scored.",
            formUuid: row.formUuid,
          });
          return;
        }
      }
      if (
        formComponentsAnswersError &&
        formComponentsAnswersError.graphQLErrors[0].message === "Signature has expired"
      ) {
        navigate(`${project_url}/signin/?next=${pathname}`);
      }

      setAlertActivateMsg({
        title: "Activate Term",
        type: "publishConfirmation",
        msg:
          "You are about to activate the term “" +
          row.name +
          "”. Do you wish to proceed?",
        termId: row.id,
        urlActivated: urlActivated,
      });
    } else {
      setAlertActivateMsg({
        title: "Deactivate Term",
        type: "publishConfirmation",
        msg:
          "You are about to deactivate the term “" +
          row.name +
          "”. Do you wish to proceed?",
        termId: row.id,
        urlActivated: urlActivated,
      });
    }
  };
  const [changeActivateStatus] = useMutation(CHANGE_ACTIVATE_STATUS_MUTATION, {
    fetchPolicy: "network-only",
  });
  const updateActivateStatus = async (termId, urlActivated) => {
    const {
      loading: loadingActivateStatus,
      error: errorActivateStatus,
      data: dataActivateStatus,
    } = await changeActivateStatus({
      variables: {
        termId: parseInt(termId),
        urlActivated: urlActivated,
      },
    });
    if (
      !loadingActivateStatus &&
      dataActivateStatus &&
      dataActivateStatus.changeActivateStatus
    ) {
      getTermsList();
    }
    if (errorActivateStatus) {
      if (errorActivateStatus.graphQLErrors[0].message === "Signature has expired")
        navigate(`${project_url}/signin/?next=${pathname}`);
    }
  };

  const [deleteTermMutation] = useMutation(DELETE_TERM_MUTATION, {
    fetchPolicy: "network-only",
  });

  const getTermsList = async () => {
    const {
      loading: termsListLoading,
      error: termsListError,
      data: termsListData,
    } = await fetchAllTerms({
      variables: {
        clientId: parseInt(clientId),
      },
    });
    if (!termsListLoading && termsListData && termsListData.allTerms) {
      setClientTermList(termsListData.allTerms);
      for (var i in termsListData.allTerms) {
        let currTerm = termsListData.allTerms[i];
        if (currTerm.current) setSelectedCurrentTerm(currTerm.termId);
        setNewTermStartDate(currTerm.endDate);
      }

      loadData = true;
    } else loadData = false;
    if (
      termsListError &&
      termsListError.graphQLErrors[0].message === "Signature has expired"
    ) {
      navigate(`${project_url}/signin/?next=${pathname}`);
    }
  };

  const previewForm = async formUuid => {
    if (formUuid) {
      const {
        loading: formComponentsAnswersLoading,
        error: formComponentsAnswersError,
        data: formComponentsAnswersData,
      } = await fetchFormComponentsAnswers({
        variables: { formUuid: formUuid },
      });

      if (
        !formComponentsAnswersLoading &&
        formComponentsAnswersData &&
        formComponentsAnswersData.formComponentAnswerList
      ) {
        if (
          formComponentsAnswersData.formComponentAnswerList.componentList.length !== 0
        ) {
          window.open(`${project_url}/forms/${formUuid}/preview`);
        } else {
          setPreviewAlertMsg({
            title: "Preview Form",
            msg: "This form has no object. Nothing to preview.",
          });
        }
      }
      if (
        formComponentsAnswersError &&
        formComponentsAnswersError.graphQLErrors[0].message === "Signature has expired"
      ) {
        navigate(`${project_url}/signin/?next=${pathname}`);
      }
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);

  useEffect(() => {
    (() => getCurrClientUuid())();
  }, [clientId]);

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => getTermsList())();
  }, []);

  useEffect(() => {
    currentTerm &&
      (() =>
        navigate(`${project_url}/terms/` + currentTerm.termUuid + "/teams-assignment"))();
  }, [currentTerm]);

  const termTemplateOptions = React.useMemo(() => {
    if (!clientTermList) return [];

    return [
      ...new Set(clientTermList.map(term => term.termTemplate?.name).filter(Boolean)),
    ];
  }, [clientTermList]);

  useEffect(() => {
    if (termTemplateOptions.length > 0 && !selectedTemplate) {
      setSelectedTemplate(termTemplateOptions[0]);
    }
  }, [termTemplateOptions, selectedTemplate]);

  const filteredTerms = React.useMemo(() => {
    if (!selectedTemplate) return clientTermList;

    return clientTermList.filter(term => term.termTemplate?.name === selectedTemplate);
  }, [clientTermList, selectedTemplate]);

  function checkDeleteStatus(row) {
    if (row.status === "Active" && row.noOfApplicants > 0)
      setAlertDeleteMsg({
        title: "Delete Term",
        msg: "You cannot delete this term, because at least one applicant has filled out its form.",
      });
    else
      setAlertDeleteMsg({
        title: "Delete Term",
        type: "deleteConfirmation",
        msg: "Are you sure you want to delete the term “" + row.name + "”?",
        termId: row.id,
      });
  }

  const deleteTerm = async termId => {
    const {
      loading: loadingTermDelete,
      error: errorTermDelete,
      data: dataTermDelete,
    } = await deleteTermMutation({
      variables: {
        termId: parseInt(termId),
      },
    });
    if (!loadingTermDelete && dataTermDelete && dataTermDelete.deleteTerm) {
      getTermsList();
    }
    if (errorTermDelete) {
      if (errorTermDelete.graphQLErrors[0].message === "Signature has expired")
        navigate(`${project_url}/signin/?next=${pathname}`);
      else alert(errorTermDelete.graphQLErrors[0].message);
    }
  };

  const columns = [
    {
      field: "name",
      headerName: "Name",
      minWidth: 150,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        return rows.row.current ? (
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <StyledTooltip title="View Public Form">
              <img
                style={{ marginRight: 10, cursor: "pointer", marginTop: 15 }}
                src={previewImg}
                onClick={() =>
                  window.open(`${project_url}/client/` + clientUuid + "/application-form")
                }
              />
            </StyledTooltip>
            <StyledTooltip title="Current Term">
              <Typography variant="h3" style={{ fontSize: 14, marginTop: 15 }}>
                {rows.row.name}
              </Typography>
            </StyledTooltip>
          </Box>
        ) : (
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {rows.row.name}
          </Box>
        );
      },
    },
    {
      field: "startDate",
      headerName: "Start Date",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "endDate",
      headerName: "End Date",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "noOfSeats",
      headerName: "No of Seats",
      minWidth: 80,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },

    {
      field: "noOfApplicants",
      headerName: "No of Applicants",
      minWidth: 50,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },

    {
      field: "noOfTeams",
      headerName: "No of Teams",
      minWidth: 50,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },

    {
      field: "formName",
      headerName: "Form Name",
      minWidth: 230,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        return (
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {rows.row.formName}
            {rows.row.previewAccess ? (
              <StyledTooltip title="Preview form">
                <img
                  style={{ marginLeft: 5, cursor: "pointer" }}
                  src={previewImg}
                  onClick={() => previewForm(rows.row.formUuid)}
                />
              </StyledTooltip>
            ) : (
              <StyledTooltip title="Preview form">
                <img
                  style={{
                    marginLeft: 5,
                    cursor: "pointer",
                    filter: "grayscale(1)",
                    opacity: 0.5,
                  }}
                  src={previewImg}
                />
              </StyledTooltip>
            )}
          </Box>
        );
      },
    },
    {
      field: "status",
      headerName: "Term Status",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },

    {
      field: "action",
      headerName: "Action",
      minWidth: 250,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        var notesPath =
          `${project_url}/terms/` + rows.row.termUuid + "/teams-resources-note";
        var editPath = `${project_url}/terms/` + rows.row.termUuid;
        var applicantsPath = `${project_url}/terms/` + rows.row.termUuid + "/applicants";
        var attendancePath =
          `${project_url}/terms/` + rows.row.termUuid + "/teams-resources-attendance";

        var editFilter = rows.row.editAccess ? "none" : "grayscale(1)";
        var editOpacity = rows.row.editAccess ? 1 : 0.5;
        var editCursor = rows.row.editAccess ? "pointer" : "auto";

        var deleteFilter = rows.row.deleteAccess ? "none" : "grayscale(1)";
        var deleteOpacity = rows.row.deleteAccess ? 1 : 0.5;
        var deleteCursor = rows.row.deleteAccess ? "pointer" : "auto";

        var assignTeamsFilter = rows.row.assignTeamsAccess ? "none" : "grayscale(1)";
        var assignTeamsOpacity = rows.row.assignTeamsAccess ? 1 : 0.5;
        var assignTeamsCursor = rows.row.assignTeamsAccess ? "pointer" : "auto";

        var lockFilter = rows.row.lockAccess ? "none" : "grayscale(1)";
        var lockOpacity = rows.row.lockAccess ? 1 : 0.5;
        var lockCursor = rows.row.lockAccess ? "pointer" : "auto";

        var listOfApplicantsFilter = rows.row.listOfApplicantsAccess
          ? "none"
          : "grayscale(1)";
        var listOfApplicantsOpacity = rows.row.listOfApplicantsAccess ? 1 : 0.5;
        var listOfApplicantsCursor = rows.row.listOfApplicantsAccess ? "pointer" : "auto";

        var attendanceCursor = rows.row.attendanceAccess ? "pointer" : "auto";
        var noteCursor = rows.row.noteAccess ? "pointer" : "auto";

        return (
          <Box
            pt={1}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <StyledTooltip title={rows.row.noOfTeams > 0 ? "Teams Resources Attendance" : "Teams Resources Attendance : no team"} >
              <HowToRegOutlinedIcon
                color={(rows.row.attendanceAccess && rows.row.noOfTeams > 0) ? "action" : "disabled"}
                style={{
                  paddingRight: 10,
                  paddingTop: 6,
                  cursor: listOfApplicantsCursor,
                  fontSize: 24,
                }}
                // onClick={() =>
                //   rows.row.attendanceAccess ? navigate(attendancePath) : ""
                // }
                onClick={() =>
                  rows.row.attendanceAccess
                    ? handleTermAction(rows.row, () => navigate(attendancePath))
                    : ""
                }
              />
            </StyledTooltip>
            <StyledTooltip title={rows.row.noOfTeams > 0 ? "Teams Resources Note" : "Teams Resources Note: no team"}>
              <EditNoteOutlinedIcon
                color={(rows.row.noteAccess && rows.row.noOfTeams > 0) ? "action" : "disabled"}
                style={{
                  paddingRight: 10,
                  paddingTop: 6,
                  cursor: lockCursor,
                  fontSize: 24,
                  filter: lockFilter,
                  opacity: lockOpacity,
                }}
                // onClick={() => (rows.row.noteAccess ? navigate(notesPath) : "")}
                onClick={() =>
                  rows.row.noteAccess
                    ? handleTermAction(rows.row, () => navigate(notesPath))
                    : ""
                }
              />
            </StyledTooltip>
            <StyledTooltip title="Assign teams">
              <Diversity3Icon
                color="action"
                style={{
                  paddingRight: 10,
                  paddingTop: 6,
                  cursor: assignTeamsCursor,
                  fontSize: 24,
                  filter: assignTeamsFilter,
                  opacity: assignTeamsOpacity,
                }}
                // onClick={() =>
                //   rows.row.assignTeamsAccess ? setCurrentTerm(rows.row) : ""
                // }
                onClick={() =>
                  rows.row.assignTeamsAccess
                    ? handleTermAction(rows.row, () => setCurrentTerm(rows.row))
                    : ""
                }
              />
            </StyledTooltip>

            <>
              {rows.row.status === "Active" ? (
                <StyledTooltip title="Deactivate this term">
                  <LockOpenOutlinedIcon
                    color="action"
                    style={{
                      paddingRight: 10,
                      paddingTop: 6,
                      cursor: lockCursor,
                      fontSize: 24,
                      filter: lockFilter,
                      opacity: lockOpacity,
                    }}
                    // onClick={() =>
                    //   rows.row.lockAccess ? confirmActivateStatus(rows.row, false) : ""
                    // }
                    onClick={() =>
                      rows.row.lockAccess
                        ? handleTermAction(rows.row, () =>
                            confirmActivateStatus(rows.row, false),
                          )
                        : ""
                    }
                  />
                </StyledTooltip>
              ) : (
                <StyledTooltip title="Activate this term">
                  <LockOutlinedIcon
                    color="action"
                    style={{
                      paddingRight: 10,
                      paddingTop: 6,
                      cursor: lockCursor,
                      fontSize: 24,
                      filter: lockFilter,
                      opacity: lockOpacity,
                    }}
                    // onClick={() =>
                    //   rows.row.lockAccess ? confirmActivateStatus(rows.row, true) : ""
                    // }

                    onClick={() =>
                      rows.row.lockAccess
                        ? handleTermAction(rows.row, () =>
                            confirmActivateStatus(rows.row, true),
                          )
                        : ""
                    }
                  />
                </StyledTooltip>
              )}
            </>

            <StyledTooltip title="List of applicants">
              <PeopleIcon
                color="action"
                style={{
                  paddingRight: 10,
                  paddingTop: 6,
                  cursor: listOfApplicantsCursor,
                  fontSize: 24,
                  filter: listOfApplicantsFilter,
                  opacity: listOfApplicantsOpacity,
                }}
                // onClick={() =>
                //   rows.row.listOfApplicantsAccess ? navigate(applicantsPath) : ""
                // }
                onClick={() =>
                  rows.row.listOfApplicantsAccess
                    ? handleTermAction(rows.row, () => navigate(applicantsPath))
                    : ""
                }
              />
            </StyledTooltip>

            <StyledTooltip title="Edit this term">
              <img
                style={{
                  paddingRight: 10,
                  cursor: editCursor,
                  paddingTop: 6,
                  height: 24,
                  weight: 24,
                  filter: editFilter,
                  opacity: editOpacity,
                }}
                src={penImg}
                // onClick={() => (rows.row.editAccess ? navigate(editPath) : "")}
                onClick={() =>
                  rows.row.editAccess
                    ? handleTermAction(rows.row, () => navigate(editPath))
                    : ""
                }
              />
            </StyledTooltip>

            <StyledTooltip title="Delete this term">
              <img
                style={{
                  paddingRight: 10,
                  cursor: deleteCursor,
                  paddingTop: 6,
                  height: 24,
                  weight: 24,
                  filter: deleteFilter,
                  opacity: deleteOpacity,
                }}
                src={trashImg}
                // onClick={() => (rows.row.deleteAccess ? checkDeleteStatus(rows.row) : "")}
                onClick={() =>
                  rows.row.deleteAccess
                    ? handleTermAction(rows.row, () => checkDeleteStatus(rows.row))
                    : ""
                }
              />
            </StyledTooltip>
          </Box>
        );
      },
    },
  ];

  const getPeriodColumns = () => {
    let periodsMap = new Map();

    filteredTerms.forEach(term => {
      if (term.termPeriods) {
        term.termPeriods.forEach(period => {
          // Only include periods that have real dates
          if (period.startDate || period.endDate) {
            periodsMap.set(period.name, period);
          }
        });
      }
    });

    const periodsArray = Array.from(periodsMap.values());

    // Sort: non-sprint first, sprint after
    periodsArray.sort((a, b) => {
      if (a.inSprint === b.inSprint) return 0;
      return a.inSprint ? 1 : -1;
    });

    return periodsArray;
  };

  var rows = clientTermList.map(currTerm => ({
    id: currTerm.termId,
    termUuid: currTerm.termUuid,
    name: currTerm.name,
    startDate: dayFormat(currTerm.startDate),
    endDate: dayFormat(currTerm.endDate),
    noOfSeats: currTerm.noOfSeats,
    formName: currTerm.formId.name,
    formUuid: currTerm.formId.formUuid,
    status: currTerm.urlActivated === true ? "Active" : "Inactive",
    publicFormURLVal: currTerm.urlActivated,
    noOfApplicants: currTerm.noOfApplicants,
    noOfTeams: currTerm.noOfTeams,
    current: currTerm.current,
    endDateTime: currTerm.endDate,
    editAccess: editAccess,
    deleteAccess: deleteAccess,
    assignTeamsAccess: assignTeamsAccess,
    lockAccess: lockAccess,
    listOfApplicantsAccess: listOfApplicantsAccess,
    attendanceAccess: attendanceAccess,
    noteAccess: noteAccess,
    previewAccess: previewAccess,
  }));

  const datesViewColumns = React.useMemo(() => {
    const periodColumns = getPeriodColumns();

    return [
      {
        field: "name",
        headerName: "Name",
        minWidth: 150,
        align: "center",
        headerAlign: "center",
        disableColumnMenu: true,
        renderCell: rows => rows.row.name,
      },

      ...periodColumns.map(period => ({
        field: `period_${period.name}`,
        headerName: period.name,
        width: 220,
        flex: 0,
        headerClassName: "period-header",
        align: "center",
        headerAlign: "center",
        sortable: false,
        disableColumnMenu: true,

        renderHeader: () => (
          <Box
            textAlign="center"
            style={{
              height: "100%",
              width: 200,
              minHeight: 90,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              backgroundColor: period.inSprint ? "#E2F2FF" : "#FFFF80",
              padding: 5,
              wordBreak: "break-word",
            }}
          >
            <Box>
              <Typography
                variant="h2"
                style={{
                  fontSize: 12,
                  paddingBottom: period.name.length <= 28 ? 16 : 5,
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                }}
              >
                {period.name}
              </Typography>
            </Box>
            <Box>
              <Typography
                variant="h2"
                style={{
                  fontSize: 12,
                }}
              >
                Start - End
              </Typography>
            </Box>
          </Box>
        ),

        renderCell: params => {
          const term = clientTermList.find(t => t.termId === params.row.id);
          const p = term?.termPeriods?.find(tp => tp.name === period.name);

          if (!p) return "-";

          return (
            <Box>
              <div>
                {dayFormat(p.startDate)} - {dayFormat(p.endDate)}
              </div>
            </Box>
          );
        },
      })),
    ];
  }, [filteredTerms]);

  var datesViewRows = filteredTerms.map(currTerm => ({
    id: currTerm.termId,
    name: currTerm.name,
    current: currTerm.current,
  }));

  const termAddFunc = async () => {
    const {
      loading: loadingClientHasPubForm,
      error: errorClientHasPubForm,
      data: dataClientHasPubForm,
    } = await clientHasPubForm({
      variables: {
        clientId: parseInt(clientId),
      },
    });
    if (!loadingClientHasPubForm && dataClientHasPubForm) {
      if (dataClientHasPubForm.clientHasPubForm) {
        setAddTermInputDialog(true);
      } else
        setAlertClientHasNoPushFrm({
          title: "Publish Form",
          type: "goPublishFormPage",
          msg: "There is no published form to assign to a new term. Publish at least one form before you can add a new term.",
        });
    }
  };

  const getCurrentTerm = () => {
    return clientTermList.find(term => term.current === true);
  };

  const isPastTerm = row => {
    // Current term should not show warning
    if (row.current === true) {
      return false;
    }

    const currentTerm = getCurrentTerm();

    if (!currentTerm) {
      return false;
    }

    const currentTermEndDate = new Date(currentTerm.endDate);
    const termStartDate = new Date(row.startDate);

    // Future terms should not show warning
    if (termStartDate > currentTermEndDate) {
      return false;
    }

    return true;
  };

  const handleTermAction = (row, action) => {
    if (isPastTerm(row)) {
      // Past/completed term: show warning
      setTermCompletedWarning({
        termName: row.name,
        action: action,
      });
      return;
    }
    action();
  };

  const continueTermAction = () => {
    if (termCompletedWarning.action) {
      termCompletedWarning.action();
    }
    setTermCompletedWarning({});
  };

  const cancelTermAction = () => {
    setTermCompletedWarning({});
  };

  function DataGridTitle() {
    return (
      <>
        <Grid
          container
          xs={12}
          style={{
            paddingTop: 5,
            paddingBottom: 6,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item xs={2}>
            <FormControl>
              <InputLabel>Term View</InputLabel>
              <Select
                label="Term View"
                className={classes.selectStyle}
                margin="normal"
                value={termView}
                onChange={e => setTermView(e.target.value)}
              >
                <MenuItem value="info">By Info</MenuItem>
                <MenuItem value="dates">By Dates</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={7} style={{ textAlign: "center" }}>
            <Typography variant="h1" style={{ fontSize: 20, paddingLeft: 100 }}>
              Terms
            </Typography>
          </Grid>
          <Grid
            item
            xs={2}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingRight: 10,
            }}
          >
            <Button
              variant="contained"
              size="small"
              className={classes.largeButtonStyle}
              disabled={!setCurrentTermAccess ? "disabled" : ""}
              onClick={() => (setCurrentTermAccess ? setCurrentTermDialog(true) : "")}
            >
              Set Current Term
            </Button>
          </Grid>
          <Grid
            item
            xs={1}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingRight: 10,
            }}
          >
            <Button
              variant="contained"
              size="small"
              className={classes.buttonStyle}
              disabled={!addAccess ? "disabled" : ""}
              onClick={() => (addAccess ? termAddFunc() : "")}
            >
              Add
            </Button>
          </Grid>
        </Grid>
        <Divider />
      </>
    );
  }

  function DatesViewDataGrid() {
    return (
      <>
        <Grid
          container
          xs={12}
          style={{
            paddingTop: 5,
            paddingBottom: 6,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item xs={4} style={{ textAlign: "left", paddingLeft: 45 }}>
            <FormControl>
              <InputLabel>Term View</InputLabel>
              <Select
                label="Term View"
                className={classes.selectStyle}
                style={{ marginRight: 10 }}
                margin="normal"
                value={termView}
                onChange={e => setTermView(e.target.value)}
              >
                <MenuItem value="info">By Info</MenuItem>
                <MenuItem value="dates">By Dates</MenuItem>
              </Select>
            </FormControl>
            <FormControl
              variant="outlined"
              className={classes.selectTemplateStyle}
              size="small"
            >
              <InputLabel>Term Template</InputLabel>
              <Select
                label="Term template"
                className={classes.selectTemplateStyle}
                margin="normal"
                value={selectedTemplate}
                onChange={e => setSelectedTemplate(e.target.value)}
              >
                {termTemplateOptions.map(templateName => (
                  <MenuItem key={templateName} value={templateName}>
                    {templateName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={8} style={{ textAlign: "left" }}>
            <Typography variant="h1" style={{ fontSize: 20 }}>
              Terms
            </Typography>
          </Grid>
        </Grid>
        <Divider />
      </>
    );
  }

  if (loadContent)
    if (loadData)
      if (access)
        return (
          <div className={classes.root}>
            <Header />
            <div className={classes.container}>
              {termView === "info" ? (
                <PersistentDataGrid
                  persistenceKey="terms-list"
                  className={classes.dataGridStyle}
                  columns={columns}
                  rows={rows}
                  showCellRightBorder={true}
                  slots={{
                    toolbar: DataGridTitle,
                  }}
                  getRowId={row => row.id}
                  autoHeight={true}
                  experimentalFeatures={{ newEditingApi: true }}
                  initialState={{
                    pagination: { paginationModel: { pageSize: 50 } },
                  }}
                  pageSizeOptions={[10, 25, 50]}
                  getRowClassName={params => (params.row.current ? "current-row" : "")}
                />
              ) : (
                <Box sx={{ width: "100%", overflowX: "auto" }}>
                  <DataGrid
                    className={classes.dataGridStyle}
                    columns={datesViewColumns}
                    sx={{
                      minWidth: "max-content",
                      "& .period-header": {
                        padding: 0,
                      },
                      "& .period-header .MuiDataGrid-columnHeaderTitle": {
                        whiteSpace: "normal !important",
                        overflow: "visible !important",
                        textOverflow: "unset !important",
                        lineHeight: "1.2rem",
                        textAlign: "center",
                      },
                      "& .MuiDataGrid-columnHeader": {
                        height: "auto !important",
                        maxHeight: "none !important",
                      },
                      "& .MuiDataGrid-columnHeaders": {
                        maxHeight: "none !important",
                      },
                      "& .MuiDataGrid-columnHeader.period-header": {
                        padding: 0,
                      },
                      "& .MuiDataGrid-columnHeader.period-header .MuiDataGrid-columnHeaderTitleContainer":
                        {
                          paddingRight: 0.5,
                          paddingLeft: 0.5,
                          height: "100%",
                          width: "100%",
                        },
                      "& .MuiDataGrid-columnHeader.period-header .MuiDataGrid-columnHeaderTitleContainerContent":
                        {
                          paddingRight: 0.5,
                          paddingLeft: 0.5,
                          height: "100%",
                          width: "100%",
                        },
                    }}
                    rows={datesViewRows}
                    showCellRightBorder={true}
                    slots={{
                      toolbar: DatesViewDataGrid,
                    }}
                    getRowId={row => row.id}
                    autoHeight={true}
                    experimentalFeatures={{ newEditingApi: true }}
                    initialState={{
                      pagination: { paginationModel: { pageSize: 50 } },
                      sorting: {
                        sortModel: [{ field: "endDate", sort: "desc" }],
                      },
                    }}
                    getCellClassName={rows => {
                      if (rows.row.index === 0) return "colSpan";
                    }}
                    pageSizeOptions={[10, 25, 50]}
                    getRowClassName={params => (params.row.current ? "current-row" : "")}
                  />
                </Box>
              )}
              <style>
                {`
              .current-row {
                background-color: rgba(203, 255, 139, 0.33) !important; /* Light green */
              }
            `}
              </style>
              {previewAlertMsg.msg && (
                <AlertDialog
                  title={previewAlertMsg.title}
                  contentMsg={previewAlertMsg.msg}
                  closeDialog={() => {
                    setPreviewAlertMsg([]);
                  }}
                />
              )}
              {alertActivateMsg.msg && (
                <AlertDialog
                  title={alertActivateMsg.title}
                  type={alertActivateMsg.type}
                  contentMsg={alertActivateMsg.msg}
                  closeDialog={() => setAlertActivateMsg([])}
                  publishAction={() => {
                    setAlertActivateMsg([]);
                    updateActivateStatus(
                      alertActivateMsg.termId,
                      alertActivateMsg.urlActivated,
                    );
                  }}
                />
              )}
              {alertDeleteMsg.msg && (
                <AlertDialog
                  title={alertDeleteMsg.title}
                  type={alertDeleteMsg.type}
                  contentMsg={alertDeleteMsg.msg}
                  closeDialog={() => setAlertDeleteMsg([])}
                  deleteAction={() => {
                    setAlertDeleteMsg([]);
                    deleteTerm(alertDeleteMsg.termId);
                  }}
                />
              )}

              {alertGoFrmScoresPageMsg.msg && (
                <AlertDialog
                  title={alertGoFrmScoresPageMsg.title}
                  type={alertGoFrmScoresPageMsg.type}
                  contentMsg={alertGoFrmScoresPageMsg.msg}
                  closeDialog={() => setAlertGoFrmScoresPageMsg([])}
                  goScorePageAction={() => {
                    setAlertGoFrmScoresPageMsg([]);
                    goFrmScoresPageFunc(alertGoFrmScoresPageMsg.formUuid);
                  }}
                />
              )}
              {addTermInputDialog && (
                <AddTermInputDialog
                  closeDialog={() => setAddTermInputDialog(false)}
                  defaultStartDate={newTermStartDate}
                />
              )}
              {currentTermDialog && (
                <SelectCurrentTermDialog
                  closeDialog={() => {
                    setCurrentTermDialog(false);
                    getTermsList();
                  }}
                  termsList={rows}
                  selectedCurrentTerm={selectedCurrentTerm}
                />
              )}
              {alertClientHasNoPushFrm.msg && (
                <AlertDialog
                  title={alertClientHasNoPushFrm.title}
                  type={alertClientHasNoPushFrm.type}
                  contentMsg={alertClientHasNoPushFrm.msg}
                  closeDialog={() => setAlertClientHasNoPushFrm([])}
                  goPublishFormPageAction={() => {
                    setAlertClientHasNoPushFrm([]);
                    navigate(`${project_url}/forms`);
                  }}
                />
              )}
              {assignTeamInputDialog && (
                <AssignTeamInputDialog
                  closeDialog={() => {
                    setAssignTeamInputDialog(false);
                    setCurrentTerm(null);
                    getTermsList();
                  }}
                  currTerm={currentTerm}
                />
              )}
              {termCompletedWarning.termName && (
                <AlertDialog
                  title="Completed Term"
                  type="termCompletedWarning"
                  contentMsg={
                    "Warning: Term " +
                    termCompletedWarning.termName +
                    " is completed. Are you sure you wish to review or edit its information? It is recommended not to change any of its information."
                  }
                  closeDialog={cancelTermAction}
                  termCompletedOkAction={continueTermAction}
                  termCompletedCancelAction={cancelTermAction}
                />
              )}
            </div>
          </div>
        );
      else
        return (
          <div className={classes.root}>
            <div className={classes.container}>
              <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.'
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            </div>
          </div>
        );
    else
      return (
        <div className={classes.root}>
          <div className={classes.container}>
            <AlertDialog
              title="No Client"
              contentMsg="There is no client in this Tenant. Please create a client."
              closeDialog={() => {
                navigate(`${project_url}/tenant/dashboard`);
              }}
            />
          </div>
        </div>
      );
  else return;
}

export default TermList;
